import { render, staticRenderFns } from "./PopupFade.vue?vue&type=template&id=927d66d8&scoped=true&"
import script from "./PopupFade.vue?vue&type=script&lang=ts&"
export * from "./PopupFade.vue?vue&type=script&lang=ts&"
import style0 from "./PopupFade.vue?vue&type=style&index=0&id=927d66d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927d66d8",
  null
  
)

export default component.exports